import * as React from 'react';
// @ts-ignore
import Workbook from 'react-excel-workbook';
import { ItemDetail, ItemDetailToExport } from '../domain/SummaryData';
import { ItemForExcel, OrderItemForExcel } from '../domain/Product';

export interface Column {
    label: string;
    value: string;
}

interface Props {
    spreadsheetData: ItemDetail[] | ItemForExcel[] | ItemDetailToExport[] | OrderItemForExcel[];
    columns: Column[];
    name: string;
    filename: string;
}

class ExportDataToExcel extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="estimations-download-xls">
                <div className="row text-center">
                    <Workbook
                        filename={this.props.filename}
                        element={<button className="estimations-download-button" id="estimations-download-button" />}
                    >
                        <Workbook.Sheet data={this.props.spreadsheetData} name={this.props.name}>
                            {this.props.columns.map((column: Column) => {
                                return <Workbook.Column label={column.label} value={column.value} key={column.label} />;
                            })}
                        </Workbook.Sheet>
                    </Workbook>
                </div>
            </div>
        );
    }
}

export default ExportDataToExcel;



// WEBPACK FOOTER //
// ./src/view/ExportDataToExcel.tsx